import { axiosInstance } from '@/rest/axios'

const createUserPermissionsApi = () => {
  return {
    /**
     * Fetch user permissions by account number.
     * @param {string} account_number - Account number.
     * @returns {Promise<UserPermissionsData>} User permissions data for provided account number.
     */
    getUserPermissionsByAccountNumber: (account_number) =>
      axiosInstance.get(`users/user_permissions/${account_number}`),
    patch: (accountNumber, body) =>
      axiosInstance.patch(`users/user_permissions/${accountNumber}`, body),
  }
}

const userPermissionsApi = createUserPermissionsApi()

export { userPermissionsApi }
